// Mock data for the floor plan design website
export const mockProjects = [
  {
    id: 1,
    title: "Casa Familiar Moderna",
    description: "Instalación de yeso laminado con diseño contemporáneo, tabiques modulares y cielos rasos decorativos. Acabados lisos en espacios sociales y texturizados en habitaciones.",
    image: "https://images.unsplash.com/photo-1721244654210-a505a99661e9",
    category: "residential",
    area: "180",
    rooms: 3,
    bathrooms: 3,
    completedDate: "Mar 2024",
    budget: "15k-25k",
    location: "Madrid, España"
  },
  {
    id: 2,
    title: "Residencial Multifamiliar",
    description: "Proyecto de drywall para complejo habitacional con sistemas modulares de yeso laminado, divisiones acústicas entre unidades y acabados resistentes al fuego.",
    image: "https://images.unsplash.com/photo-1721244653652-268631ec049a",
    category: "residential",
    area: "450",
    rooms: 8,
    bathrooms: 6,
    completedDate: "Feb 2024",
    budget: "50k+",
    location: "Barcelona, España"
  },
  {
    id: 3,
    title: "Casa Tradicional Elegante",
    description: "Yeso laminado con estilo clásico, molduras decorativas y acabados premium. Cielos rasos ornamentales y tabiques con aislamiento acústico superior.",
    image: "https://images.unsplash.com/photo-1717250264755-f7f0177364ae",
    category: "residential",
    area: "220",
    rooms: 4,
    bathrooms: 3,
    completedDate: "Ene 2024",
    budget: "20k-30k",
    location: "Valencia, España"
  },
  {
    id: 4,
    title: "Edificio Comercial Moderno",
    description: "Sistema completo de drywall comercial con tabiques móviles, acabados ignífugos certificados y paneles acústicos especializados para oficinas corporativas.",
    image: "https://images.unsplash.com/photo-1721244653580-79577d2822a2",
    category: "commercial",
    area: "800",
    rooms: 12,
    bathrooms: 8,
    completedDate: "Dic 2023",
    budget: "50k+",
    location: "Sevilla, España"
  },
  {
    id: 5,
    title: "Estudio Arquitectónico",
    description: "Instalación especializada de yeso laminado para estudio profesional con paneles acústicos, iluminación integrada y acabados de alta calidad para espacios de trabajo.",
    image: "https://images.pexels.com/photos/8837511/pexels-photo-8837511.jpeg",
    category: "modern",
    area: "320",
    rooms: 6,
    bathrooms: 4,
    completedDate: "Nov 2023",
    budget: "30k-40k",
    location: "Bilbao, España"
  },
  {
    id: 6,
    title: "Sótano con Drywall Resistente",
    description: "Yeso laminado resistente a la humedad para sótanos, con aislamiento térmico superior y acabados especiales para áreas de alta condensación y uso múltiple.",
    image: "https://images.unsplash.com/photo-1721244654195-943615c56ac4",
    category: "residential",
    area: "150",
    rooms: 3,
    bathrooms: 2,
    completedDate: "Oct 2023",
    budget: "10k-15k",
    location: "Málaga, España"
  }
];

export const mockServices = [
  {
    id: 5,
    name: "Diseño de Planos Online",
    description: "Diseño profesional de planos arquitectónicos 100% online, desde cualquier parte del mundo",
    icon: "FileText",
    features: ["Planos técnicos detallados (2D y 3D)", "Revisiones incluidas", "Entrega digital (PDF, AutoCAD)"],
    price: "Desde $200/proyecto"
  },
  {
    id: 6,
    name: "Asesoramiento Online",
    description: "Consultoría virtual especializada para tus proyectos de drywall y diseño de espacios",
    icon: "Video",
    features: ["Videollamadas personalizadas", "Análisis remoto de proyectos", "Recomendaciones técnicas"],
    price: "Desde $100/sesión"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "María González",
    role: "Propietaria",
    content: "Pedí los planos 100% online y fue una experiencia increíble. El equipo entendió perfectamente nuestras necesidades por videollamada y entregaron un diseño que superó nuestras expectativas.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
    project: "Diseño de Planos Online"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    role: "Desarrollador Inmobiliario",
    content: "Profesionalismo excepcional. Los planos fueron entregados de forma digital en tiempo récord y con todos los detalles técnicos necesarios. Definitivamente trabajaremos juntos en futuros proyectos.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    project: "Diseño Online Premium"
  },
  {
    id: 3,
    name: "Ana Martínez",
    role: "Arquitecta",
    content: "Las sesiones de asesoramiento online fueron clave para resolver dudas técnicas de mi proyecto. Excelente atención al detalle y cumplimiento de normativas al 100%.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
    project: "Asesoramiento Online"
  }
];